/**
 * created by xcc on 2022/3/16
 * 信息认证
 */

import React, {Component} from 'react';
import {Button, Col, Input, Modal, Radio, Row, Select, Tabs} from "antd";
import {getSiteAddressData, getWebSiteList, verifyAccount} from "../actions/mediaAdminister";
import {message} from "../../sysManagement/utils/sysManagementUtils";
import {uuid} from "../../../utils";

const {TabPane} = Tabs;
const {Option} = Select;

export default class InfoAuth extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            webInfoVisible: false,
            activeKey: "1",
            siteAddress: undefined,  //站点地址
            siteAddressList: [], //站点地址数据
            siteAccount: "",  //站点账号
            sitePassword: "",  //站点密码
            bindSiteId: undefined,   //绑定站点id
            bindSiteList: [], // 绑定站点列表
            getSuccess: undefined, //获取成功
            appId: "",
            appSecret: "",
            wechatType: "1",  //公众号类型
            onlyView: false,
            websiteName: "",
            mediaId: "",
            authResult: null,
            inputSecurityKey: 1
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
        this.getSiteAddressList();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            webInfoVisible: nextProps.webInfoVisible,
            inputSecurityKey: uuid()
        })
    }

    getSiteAddressList() {
        getSiteAddressData({}, (data) => {
            let siteAddressList = [];
            if (data && data.length > 0) {
                siteAddressList = data;
            }
            this.setState({
                siteAddressList
            })
        })
    }

    revertInfoAuth(item) {
        this.state.mediaId = item.id;
        if (item.authResult === 1) {
            if (item.mediaTypeCode === "material" || item.mediaTypeCode === "baijiahao") {
                this.setState({
                    appId: item.mediaProperty.account,
                    appSecret: item.mediaProperty.password,
                    wechatType: item.mediaProperty.gzhtype
                })
            } else {
                this.setState({
                    activeKey: "1",
                    siteAddress: item.mediaProperty.clientId,  //站点地址
                    siteAccount: item.mediaProperty.account,  //站点账号
                    sitePassword: "",  //站点密码
                    bindSiteId: undefined,   //绑定站点id
                    websiteName: item.mediaProperty.websiteName, //回显站点名称
                    getSuccess: undefined,
                    onlyView: true,
                    authResult: item.authResult
                })
            }
        } else {
            this.setState({
                activeKey: "1",
                appId: "",
                appSecret: "",
                wechatType: "1",
                siteAddress: undefined,  //站点地址
                siteAccount: "",  //站点账号
                sitePassword: "",  //站点密码
                bindSiteId: undefined,   //绑定站点id
                websiteName: "", //回显站点名称
                getSuccess: undefined,
                onlyView: false,
                bindSiteList: [], // 绑定站点列表
            })
        }
    }

    //认证
    auth() {
        let params = {
            activeKey: this.state.activeKey,
            siteAddress: this.state.siteAddress,  //站点地址
            siteAccount: this.state.siteAccount,  //站点账号
            sitePassword: this.state.sitePassword,  //站点密码
            bindSiteId: this.state.bindSiteId,   //绑定站点id
            websiteName: this.state.websiteName, //站点名称
            appId: this.state.appId,
            appSecret: this.state.appSecret,
            wechatType: this.state.wechatType,  //公众号类型c
            mediaId: this.state.mediaId,
            authResult: this.state.authResult
        }
        this.props.infoAuth(params);
    }

    /**
     * 渲染
     */
    render() {
        return (
            <div>
                <Modal
                    title={this.props.mediaTypeName + "信息认证"}
                    visible={this.state.webInfoVisible}
                    width={800}
                    height={572}
                    onCancel={() => {
                        this.props.infoAuthCancel()
                    }}
                    maskClosable={false}
                    centered
                    footer={
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => {
                                this.props.infoAuthCancel()
                            }}>取消</Button>
                            <Button type={"primary"} onClick={() => {
                                this.auth()
                            }}>认证</Button>
                        </div>
                    }
                >
                    <div>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14}}>
                            {this.props.logoUrl ?
                                <img width={56}
                                     height={56}
                                     style={{
                                         marginRight: "10px",
                                         objectFit: "cover",
                                         borderRadius: "50%"
                                     }}
                                     src={this.props.logoUrl}/> : null}{this.props.name}
                        </div>
                        {
                            (() => {
                                switch (this.props.mediaTypeCode) {
                                    case "webNews" :
                                        return this.renderWebAuth();
                                    case "material" :
                                        return this.renderWechatAuth();
                                    case "baijiahao" :
                                        return this.renderWechatAuth();
                                    default :
                                        return null
                                }
                            })()
                        }
                    </div>
                </Modal>
            </div>
        )
    }

    renderWebAuth() {
        return (
            <div>
                <Tabs activeKey={this.state.activeKey} onChange={this.tabOnChange}>
                    <TabPane tab={"账号密码"} key={"1"}/>
                    <TabPane tab={"统一身份认证"} key={"2"}/>
                </Tabs>
                {this.renderContent()}
            </div>
        )
    }

    tabOnChange = (activeKey) => {
        this.setState({
            activeKey,
            bindSiteId: undefined,   //绑定站点id
            bindSiteList: [], // 绑定站点列表
            getSuccess: undefined, //获取成功
        })
    }

    renderContent() {
        console.log(this.state.sitePassword)
        return (
            <div>
                <Row>
                    <div style={{padding: 10}}>
                        <Col span={3}>
                            <div className={'myMediaTitle'}><span
                                style={{color: 'red', position: 'absolute', top: 3, left: 12}}>*</span>站群地址：
                            </div>
                        </Col>
                        <Col span={20}>
                            <Select className={'mediaAdministerContent'}
                                    placeholder={"请选择所需认证站点的登录地址"}
                                    value={this.state.siteAddress}
                                    style={{width: '100%'}}
                                    onChange={(e) => {
                                        this.state.siteAddress = e;
                                        this.setState({})
                                    }}>
                                {this.state.siteAddressList && this.state.siteAddressList.length > 0 && this.state.siteAddressList.map((item, i) => {
                                    return (
                                        <Option key={i} value={item.id}>{item.webSiteUrl}</Option>
                                    )
                                })}
                            </Select>
                            <style>{`.ant-select-selection{border: 1px solid #EEF2FB; background-color: rgba(246, 248, 253, 0.39);}`}</style>
                        </Col>
                    </div>
                </Row>
                {this.state.activeKey === "1" ?
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={3}>
                                <div className={'myMediaTitle'}><span
                                    style={{color: 'red', position: 'absolute', top: 3, left: 12}}>*</span>站点账号：
                                </div>
                            </Col>
                            <Col span={20}>
                                <Input placeholder={"请输入所需认证站点的登录账号"} className={'mediaAdministerContent'}
                                       value={this.state.siteAccount}
                                       onChange={(e) => {
                                           this.setState({siteAccount: e.target.value})
                                       }}/>
                                <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                            </Col>
                        </div>
                    </Row> : null}
                {this.state.activeKey === "1" ?
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={3}>
                                <div className={'myMediaTitle'}><span
                                    style={{color: 'red', position: 'absolute', top: 3, left: 12}}>*</span>站点密码：
                                </div>
                            </Col>
                            <Col span={20}>
                                <Input.Password key={this.state.inputSecurityKey} placeholder={"请输入所需认证站点的登录密码"} className={'mediaAdministerContent'}
                                       value={this.state.sitePassword}
                                       autocomplete="new-password"   //防止浏览器自动回显密码
                                       onChange={(e) => {
                                           this.setState({sitePassword: e.target.value})
                                       }}/>
                                <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                            </Col>
                        </div>
                    </Row> : null
                }
                <Row>
                    <div style={{padding: 10}}>
                        <Col span={3}>
                            <div className={'myMediaTitle'}><span
                                style={{color: 'red', position: 'absolute', top: 3, left: 12}}>*</span>绑定站点：
                            </div>
                        </Col>
                        <Col span={17}>
                            {
                                this.state.onlyView ?
                                    <Input style={{width: 510}} className={'mediaAdministerContent'}
                                           value={this.state.websiteName} readOnly={true}/> :
                                    <Select className={'mediaAdministerContent'}
                                            placeholder={this.state.getSuccess === 1 ? "获取成功，请选择" : this.state.getSuccess === -1 ? "获取失败，请检查站点地址等信息" : "请获取站点"}
                                            value={this.state.bindSiteId}
                                            style={{width: 510}}
                                            onChange={(e,option) => {
                                                this.state.websiteName = option.props.children;
                                                this.state.bindSiteId = e;
                                                this.setState({})
                                            }}>
                                        {this.state.bindSiteList.length > 0 && this.state.bindSiteList.map((item, i) => {
                                            return (
                                                <Option key={i} value={item.wbfirmid}>{item.wbname}</Option>
                                            )
                                        })}
                                    </Select>}
                            <style>{`.ant-select-selection{border: 1px solid #EEF2FB; background-color: rgba(246, 248, 253, 0.39);}`}</style>
                        </Col>
                        <Col span={3}>
                            <div style={{marginLeft: "4px"}}>
                                <Button onClick={() => {
                                    this.getWebSite()
                                }}>获取站点</Button>
                            </div>
                        </Col>
                    </div>
                </Row>
            </div>
        )
    }

    getWebSite() {
        //校验
        if (!this.state.siteAddress) {
            message.warn("请选择站点地址！");
            return;
        }
        let params = {
            clientId: this.state.siteAddress
        };
        // 账号密码认证需先验证账号是否正确
        if (this.state.activeKey === "1") {
            if (!this.state.siteAccount || this.state.siteAccount.trim().length === 0) {
                message.warn("请输入站点账号！");
                return;
            }
            if (!this.state.sitePassword || this.state.sitePassword.trim().length === 0) {
                message.warn("请输入站点密码！");
                return;
            }
            params.account = this.state.siteAccount;
            params.password = this.state.sitePassword;
            verifyAccount(params, (data, status) => {
                if (status === 200) {
                    getWebSiteList(params, (data, status) => {
                        if (status === 200) {
                            this.setState({
                                bindSiteList: data,
                                getSuccess: 1,
                                onlyView: false
                            })
                        }
                    }, () => {
                        this.setState({
                            getSuccess: -1,
                            onlyView: false
                        })
                    })
                }
            }, () => {
                message.error("账号或密码错误，请检查后重新输入！");
            });
        } else {
            params.account = window.currentUser.account;
            getWebSiteList(params, (data, status) => {
                if (status === 200) {
                    this.setState({
                        bindSiteList: data,
                        getSuccess: 1,
                        onlyView: false
                    })
                }
            }, () => {
                this.setState({
                    getSuccess: -1,
                    onlyView: false
                })
            })
        }
    }

    renderWechatAuth() {
        return (
            <div>
                <Row>
                    <div style={{padding: 10}}>
                        <Col span={3}>
                            <div className={'myMediaTitle'}><span
                                style={{color: 'red', position: 'absolute', top: 3, left: 28}}>*</span>AppId：
                            </div>
                        </Col>
                        <Col span={20}>
                            <Input placeholder={"请输入AppId"} className={'mediaAdministerContent'}
                                   value={this.state.appId}
                                   onChange={(e) => {
                                       this.setState({appId: e.target.value})
                                   }}/>
                            <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                        </Col>
                    </div>
                </Row>
                <Row>
                    <div style={{padding: 10}}>
                        <Col span={3}>
                            <div className={'myMediaTitle'}><span
                                style={{
                                    color: 'red',
                                    position: 'absolute',
                                    top: 3,
                                    left: this.props.mediaTypeCode === "material" ? 0 : 2
                                }}>*</span>{this.props.mediaTypeCode === "material" ? "AppSecret" : "AppToken"}：
                            </div>
                        </Col>
                        <Col span={20}>
                            <Input
                                placeholder={this.props.mediaTypeCode === "material" ? "请输入AppSecret" : "请输入AppToken"}
                                className={'mediaAdministerContent'}
                                value={this.state.appSecret}
                                onChange={(e) => {
                                    this.setState({appSecret: e.target.value})
                                }}/>
                            <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                        </Col>
                    </div>
                </Row>
                {
                    this.props.mediaTypeCode === "material" ?
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={3}>
                                    <div>
                                        <div className={'myMediaTitle'}><span
                                            style={{color: 'red', position: 'absolute', top: 3, left: -1}}>*</span>{this.props.mediaTypeName}类型：
                                        </div>
                                    </div>
                                </Col>
                                <Col span={20}>
                                    <Radio.Group style={{marginTop: "8px"}} onChange={(e) => {
                                        this.setState({
                                            wechatType: e.target.value,
                                        });
                                    }} value={this.state.wechatType}>
                                        <Radio value={"1"}>订阅号</Radio>
                                        <Radio value={"2"}>服务号</Radio>
                                    </Radio.Group>
                                </Col>
                            </div>
                        </Row> : null}
            </div>
        )
    }

}